import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Field of `technicalReview` saved by the block project-appointment-notes ("Besonderheiten bei
 * Terminierung") with its payload type (`preparePayloadForGraphQL`). Must match
 * `ProjectAppointmentNotesInput`.
 */
const PROJECT_APPOINTMENT_NOTES_FIELD_TYPES = {
  appointmentNotes: 'string',
};

export const PROJECT_APPOINTMENT_NOTES_INPUT_FIELDS = Object.keys(
  PROJECT_APPOINTMENT_NOTES_FIELD_TYPES
);

/** `ProjectAppointmentNotesInput` from the block object: `appointmentNotes` of `technicalReview`. */
export const toProjectAppointmentNotesInput = (project) =>
  preparePayloadForGraphQL(project.technicalReview ?? {}, PROJECT_APPOINTMENT_NOTES_FIELD_TYPES);
